import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import Lowarrow from "../../../asset/images/low-arrow.svg";
import UpArrow from "../../../asset/images/up-arrow.svg";
import { Constants } from "../../../CommonMethhods/Constants";
import {
  forToFix,
  numDifferentiation,
  numDifferentiationWithoutSymbol,
} from "../../../CommonMethhods/CovertRupees";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  getTabStatus,
  goToClientDashboard,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { duration } from "moment/moment";
import Loader from "../../Common/Loader";
import SmallLoader from "../../Common/smallLoader";

function AumSnapshot(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [loader, setLoader] = useState(true);
  const revenueTable = props.revenueTableData;
  const [duration, setDuration] = useState("");
  const [aumEquModel, setAumEquModel] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  // const [infiniteScrollLoader, setInfiniteScrollLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const title = props.title.split(" ")[0];
  const firstColumnTitle = title === "Sales" ? "Turnover" : title;
  // const overall = revenueTable.overall;
  const yesterday = revenueTable.yesterday;
  const weekly = revenueTable.weekly;
  const month = revenueTable.monthly;
  const year = revenueTable.yearly;

  const rowLabels = [
    "Equity",
    // "PMS",
    "F&O",
    "Total",
  ];

  // to handle empty data and generate empt div
  // const handleifTableEmptyoverall = (flag) => {
  //   const tempArray = [
  //     [0],

  //     [0],
  //     [0],
  //   ];

  // return tempArray.map((column, index) => {
  //   return (
  //     <tr key={index}>
  //       {flag === true ? (
  //         <th className="text-left header-width">{rowLabels[index]}</th>
  //       ) : (
  //         <></>
  //       )}
  //       {column.map((index) => {
  //         return (
  //           <td key={index} className="snapshot-table-column">
  //             {"0"}
  //           </td>
  //         );
  //       })}
  //     </tr>
  //   );
  // });
  // };
  const handleifTableEmpty = (flag) => {
    const tempArray = [
      [0, 0, 0, 0],
      // [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ];

    return tempArray.map((column, index) => {
      return (
        <tr key={index}>
          {flag === true ? (
            <th className="text-left header-width">{rowLabels[index]}</th>
          ) : (
            <></>
          )}
          {column.map((index) => {
            return (
              <td key={index} className="snapshot-table-column">
                {"0"}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  const getAumSnapshotEquityModel = async (
    duration,
    fileData = "grid",
    pageSize = 5
  ) => {
    if (fileData == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileData == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      pageSize: pageSize,
      pageNo: page,
      Duration: duration,
      fileType: fileData,
    };
    let encPayload = AESEncryption(payloadValue);

    try {
      const getAumEquity = await axios.post(
        DASHBOARD_DEFAULT.AUMSnapshotEquityModel_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getAumEquity?.data);

      const res = response.data;
      // if (res) {
      //   if (showModal == true) {
      //     if (fileData == "grid") {
      //       setRevenueEquModel((prev) => {
      //         return [prev, ...res.clients];
      //       });
      //     } else if (fileData == "pdf") {
      //       window.open(res, "_blank", "noopener,noreferrer");
      //     } else {
      //       window.open(res, "_blank", "noopener,noreferrer");
      //     }
      //   } else {
      //     // setActive(res.eq || res.clients)
      //     setRevenueEquModel(res.eq || res.clients);
      //   }
      // }
      if (res) {
        if (showModal == true) {
          if (fileData == "grid") {
            setAumEquModel((prev) => {
              return [...prev, ...res.clients];
            });
          } else if (fileData == "pdf") {
            window.open(res, "_blank", "noopener,noreferrer");
          } else {
            window.open(res, "_blank", "noopener,noreferrer");
          }
        } else {
          // setActive(res.eq || res.clients)
          setAumEquModel(res.eq || res.clients);
        }
      }
      setLoader(false);
      // setInfiniteScrollLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      // setInfiniteScrollLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
  };

  const onHide = () => {
    setShowModal(false);
    setPage(1);
    setAumEquModel([]);
  };

  const handleViewClick = (column, duration) => {
    setDuration(duration);
    if (column == "equity") {
      setShowModal(true);
      setLoader(true);
      // setPage(1);
      getAumSnapshotEquityModel(duration);
      // alert(duration);
    }
  };

  const handleScroll = () => {
    if (showModal == true) {
      const a = document.querySelector("#aum-equ");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        setPage((prev) => prev + 1);
        // setInfiniteScrollLoader(true);
        getAumSnapshotEquityModel(duration);
      }
    }
    // else {
    //   setPage(1);
    // }
  };

  const generateOverallTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].revenue = rows[column].revenue || 0;
      rows[column].revenueExist = rows[column].revenueExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row">
          {flag == true ? (
            <th className="text-left header-width"> {rowLabels[index]}</th>
          ) : (
            <></>
          )}
          <td
            key={index}
            className="snapshot-table-column overall-aum"
            onClick={() => handleViewClick(column, "Yesterday")}
            // onClick={() => handleViewClick(column, flag)}
          >
            <>
              <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              />
              <>
                {columnValues.revenue == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.revenue, 1)}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.revenueExist == 0
                  ? "text-muted"
                  : columnValues.revenueExist < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.revenueExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.revenueExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
        </tr>
      );
    });
  };

  //handle data
  const generateSnapshotTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].revenue = rows[column].revenue || 0;
      rows[column].revenueExist = rows[column].revenueExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row">
          {flag == true ? (
            <th className="text-left header-width"> {rowLabels[index]}</th>
          ) : (
            <></>
          )}

          <td
            className="snapshot-table-column overall-aum"
            onClick={() => handleViewClick(column, flag)}
          >
            <>
              <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              />
              <>
                {/* <a
                  className="overall-revenue"
                  onClick={() => handleViewClick(column, "Overall")}
                > */}
                {columnValues.revenue == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.revenue)}
                {/* </a> */}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.revenueExist == 0
                  ? "text-muted"
                  : columnValues.revenueExist < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.revenueExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.revenueExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          {/* <br /> */}
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                  ? "red-txt"
                  : "green-txt"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>

          {/* {Object.keys(columnValues).map((value, index) => {
            return (
              <td key={index} className="snapshot-table-column">
                {index == 0 ? (
                  <img
                    src={
                      columnValues[value] === 0
                        ? ""
                        : columnValues[value] < 0
                        ? Lowarrow
                        : UpArrow
                    }
                    alt=""
                  />
                ) : (
                  ""
                )}
                {columnValues[value] == undefined || null
                  ? "0"
                  : columnValues[value]}
              </td>
            );
          })} */}
        </tr>
      );
    });
  };

  const showAumeEquModal = (aumEquModel) => {
    return (
      aumEquModel &&
      aumEquModel.map((info, key) => {
        return (
          <tr key={key}>
            <td>
              <a
                href="/client-dashboard"
                onClick={() => {
                  goToClientDashboard(info.clientCode, "");
                  // Navigate("/client-dashboard");
                  getTabStatus("")
                }}
              >
                {checkEmpty(info.clientCode) ? "-" : info.clientCode}
              </a>
            </td>
            <td>{checkEmpty(info.avgPrice) ? "-" : info.avgPrice}</td>
            <td>{checkEmpty(info.isin) ? "-" : info.isin}</td>
            <td>{checkEmpty(info.holdingValue) ? "-" : info.holdingValue}</td>
            <td>
              {checkEmpty(info.mtfCollPld)
                ? "-"
                : numDifferentiationWithoutSymbol(info.mtfCollPld, 1)}
            </td>
            <td>
              {checkEmpty(info.mtfPld)
                ? "-"
                : numDifferentiationWithoutSymbol(info.mtfPld, 1)}
            </td>
            <td>{checkEmpty(info.totalHold) ? "-" : info.totalHold}</td>
          </tr>
        );
      })
    );
  };

  const handleFileType = (e) => {
    if (e.target.value) {
      props.handleOnClickSnapFileType(e.target.value, "AUM");
    }
  };
  return (
    <div className="snapshot-detail-block revenue-detail aum-report">
      <div className="card-title mb-0">
        <h2>
          {props.title}
          {/* <span>{Constants.Amount_In_Lacs}</span> */}
        </h2>
        <div className="generate-btn-wrapper mt-0">
          <button
            className="generate-btn excel1 text-green"
            value="excel"
            onClick={(e) => handleFileType(e)}
          >
            {props?.buttonLoader?.excel ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                Excel
              </>
            )}
          </button>
          <button
            className="generate-btn pdf1 txt-purple"
            value="pdf"
            onClick={(e) => handleFileType(e)}
          >
            {props?.buttonLoader?.pdf ? (
              <SmallLoader />
            ) : (
              <>
                <span className="icon-pdfsvg"></span> PDF
              </>
            )}
          </button>
        </div>
      </div>

      <div className="snapshot-table scroll-table">
        <table className="table tabel-level1">
          <tr className="for-gap">
            <td className="for-width">
              <table className="table table-level2">
                <thead>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Yesterday}
                      {/* {Constants.Overall} */}
                      <br />
                      <span>{Constants.Compare_Yesterday}</span>
                    </th>
                  </tr>
                  <tr>
                    {/* <th></th> */}
                    {/* <th className="header-width"></th> */}
                    <th scope="col" className="header-width"></th>
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {yesterday == null || undefined
                    ? handleifTableEmpty(true)
                    : generateSnapshotTableData(yesterday, true)} */}
                  {yesterday == null || undefined
                    ? handleifTableEmpty(true)
                    : generateOverallTableData(yesterday, true)}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level3">
                <thead>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Current_Week}
                      <br />
                      <span>{Constants.Compare_Week}</span>
                    </th>
                  </tr>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    {/* <th scope="col">
                      {Constants.Change}
                      <br />
                      {Constants.Change_Perc}
                    </th> */}
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {weekly == null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(weekly, "Weekly")}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level4">
                <thead>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Current_Month}
                      <br />
                      <span>{Constants.Compare_Month}</span>
                    </th>
                  </tr>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    {/* <th scope="col">
                      {Constants.Change}
                      <br />
                      {Constants.Change_Perc}
                    </th> */}
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {month == null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(month, "Monthly")}
                </tbody>
              </table>
            </td>
            <td>
              <table className="table table-level5">
                <thead>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th
                      colSpan="3"
                      scope="col"
                      className="col-width-tab text-center"
                    >
                      {Constants.Current_Year}
                      <br />
                      <span>{Constants.Compare_Year}</span>
                    </th>
                  </tr>
                  <tr>
                    {/* <th className="header-width"></th> */}
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    {/* <th scope="col">
                      {Constants.Change}
                      <br />
                      {Constants.Change_Perc}
                    </th> */}
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr>
                </thead>
                <tbody>
                  {year == null || undefined
                    ? handleifTableEmpty()
                    : generateSnapshotTableData(year, "Yearly")}
                </tbody>
              </table>
            </td>
          </tr>
        </table>
      </div>
      <Modal
        show={showModal}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <p>{Constants.AUM_Snapshot}</p>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : aumEquModel && aumEquModel.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>{Constants.Client_Code}</th>
                    <th>{Constants.Average_Price}</th>
                    <th>{Constants.Isin}</th>
                    <th>{Constants.Holding_Value}</th>
                    <th>MTF Coll Pld</th>
                    <th>MTF Pld</th>
                    <th>{Constants.Total_Holdings}</th>
                  </tr>
                </thead>

                <tbody id="aum-equ" onScroll={handleScroll}>
                  {showAumeEquModal(aumEquModel)}
                  {/* <div className="equity-center">
                    {infiniteScrollLoader && <Loader />}
                  </div> */}
                </tbody>
              </table>
            ) : (
              noDataFound()
            )}
          </div>
          <div className="generate-btn-wrapper">
            <button
              className="generate-btn text-green"
              value="excel"
              onClick={(e) =>
                getAumSnapshotEquityModel(duration, e.target.value, -1)
              }
            >
              {smallLoaderExcel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {"Excel"}
                </>
              )}
            </button>
            <button
              className="generate-btn txt-purple"
              value="pdf"
              onClick={(e) =>
                getAumSnapshotEquityModel(duration, e.target.value, -1)
              }
            >
              {smallLoaderPdf ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-pdfsvg"></span> {"PDF"}
                </>
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default React.memo(AumSnapshot);
